export { default } from './EventHotel';
